// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddingFilesModal__containerFields___GQFU6 {
    justify-content: flex-end;
    width: 100%;
}

.AddingFilesModal__coordinatesFields___R65WF {
    display: grid;
    grid-template-columns: 49% 49%;
    -moz-column-gap: 2%;
         column-gap: 2%;
}

/* stylelint-disable-next-line selector-class-pattern -- Класс Consta */
.AddingFilesModal__rootContainer___wETVJ .ChoiceGroup-Label {
    width: 100%;
}

.AddingFilesModal__window___TleM5 {
    width: 56rem;
}

.AddingFilesModal__headerTitle___xDxvn {
    margin-bottom: 0.8rem;
    line-height: 2.4rem;
}

.AddingFilesModal__coordinatesLabel___kmFqB {
    margin-top: 1.6rem;
}

.AddingFilesModal__labelChoiceGroup___rXH4c,
.AddingFilesModal__coordinatesLabel___kmFqB {
    margin-bottom: 0.8rem;
}

.AddingFilesModal__labelChoiceGroup___rXH4c,
.AddingFilesModal__headerTitleSub___OVK_Q {
    line-height: 2.1rem;
}

.AddingFilesModal__footer___HzlYo {
    padding: 2.4rem;
    background-color: var(--color-bg-secondary);
}

.AddingFilesModal__footerBtn___PDoQe {
    margin-right: 1rem;
}

.AddingFilesModal__marginBottom___WN_mB {
    margin-bottom: 1.6rem;
}

.AddingFilesModal__selectSurvey___Bh98X {
    padding: 0.8rem 2.4rem 2.4rem;
}

.AddingFilesModal__coordinatesContainer___ta5tC {
    display: flex;
    margin-top: 2.4rem;
}

.AddingFilesModal__coordinatesText___IhVFW {
    margin-bottom: 1.6rem;
    padding-right: 0.8rem;
}

.AddingFilesModal__zValues____42Ee {
    display: flex;
    align-items: center;
    margin-top: 1.6rem;
}

.AddingFilesModal__zValuesText___qo8b2 {
    padding-left: 0.8rem;
}

.AddingFilesModal__coordinatesComboboxWrapper___b4zgv {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;

    width: 100%;
    padding-bottom: 0.8rem;
}

.AddingFilesModal__containerHeader___gSKf4 {
    padding: 2.4rem;
}

.AddingFilesModal__wellPart___FuLNi {
    padding: 0.8rem 2.4rem 4rem;
}

.AddingFilesModal__wellSelect___WOdXJ {
    margin-bottom: 1.6rem;
}

.AddingFilesModal__surveyNamePart___RWX04 {
    padding: 0.8rem 2.4rem 2.4rem;
}

.AddingFilesModal__surveyNameInput___Kf6cn {
    margin-bottom: 1.6rem;
}

.AddingFilesModal__coordinatesBtn___LzXHp {
    margin-right: 0.8rem;
}

.AddingFilesModal__negativeZText___k16WE {
    margin-bottom: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/ProjectObjects/AddingFilesModal/AddingFilesModal.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAc;SAAd,cAAc;AAClB;;AAEA,uEAAuE;AACvE;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;;IAEzB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".containerFields {\n    justify-content: flex-end;\n    width: 100%;\n}\n\n.coordinatesFields {\n    display: grid;\n    grid-template-columns: 49% 49%;\n    column-gap: 2%;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- Класс Consta */\n.rootContainer :global(.ChoiceGroup-Label) {\n    width: 100%;\n}\n\n.window {\n    width: 56rem;\n}\n\n.headerTitle {\n    margin-bottom: 0.8rem;\n    line-height: 2.4rem;\n}\n\n.coordinatesLabel {\n    margin-top: 1.6rem;\n}\n\n.labelChoiceGroup,\n.coordinatesLabel {\n    margin-bottom: 0.8rem;\n}\n\n.labelChoiceGroup,\n.headerTitleSub {\n    line-height: 2.1rem;\n}\n\n.footer {\n    padding: 2.4rem;\n    background-color: var(--color-bg-secondary);\n}\n\n.footerBtn {\n    margin-right: 1rem;\n}\n\n.marginBottom {\n    margin-bottom: 1.6rem;\n}\n\n.selectSurvey {\n    padding: 0.8rem 2.4rem 2.4rem;\n}\n\n.coordinatesContainer {\n    display: flex;\n    margin-top: 2.4rem;\n}\n\n.coordinatesText {\n    margin-bottom: 1.6rem;\n    padding-right: 0.8rem;\n}\n\n.zValues {\n    display: flex;\n    align-items: center;\n    margin-top: 1.6rem;\n}\n\n.zValuesText {\n    padding-left: 0.8rem;\n}\n\n.coordinatesComboboxWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-end;\n\n    width: 100%;\n    padding-bottom: 0.8rem;\n}\n\n.containerHeader {\n    padding: 2.4rem;\n}\n\n.wellPart {\n    padding: 0.8rem 2.4rem 4rem;\n}\n\n.wellSelect {\n    margin-bottom: 1.6rem;\n}\n\n.surveyNamePart {\n    padding: 0.8rem 2.4rem 2.4rem;\n}\n\n.surveyNameInput {\n    margin-bottom: 1.6rem;\n}\n\n.coordinatesBtn {\n    margin-right: 0.8rem;\n}\n\n.negativeZText {\n    margin-bottom: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerFields": `AddingFilesModal__containerFields___GQFU6`,
	"coordinatesFields": `AddingFilesModal__coordinatesFields___R65WF`,
	"rootContainer": `AddingFilesModal__rootContainer___wETVJ`,
	"window": `AddingFilesModal__window___TleM5`,
	"headerTitle": `AddingFilesModal__headerTitle___xDxvn`,
	"coordinatesLabel": `AddingFilesModal__coordinatesLabel___kmFqB`,
	"labelChoiceGroup": `AddingFilesModal__labelChoiceGroup___rXH4c`,
	"headerTitleSub": `AddingFilesModal__headerTitleSub___OVK_Q`,
	"footer": `AddingFilesModal__footer___HzlYo`,
	"footerBtn": `AddingFilesModal__footerBtn___PDoQe`,
	"marginBottom": `AddingFilesModal__marginBottom___WN_mB`,
	"selectSurvey": `AddingFilesModal__selectSurvey___Bh98X`,
	"coordinatesContainer": `AddingFilesModal__coordinatesContainer___ta5tC`,
	"coordinatesText": `AddingFilesModal__coordinatesText___IhVFW`,
	"zValues": `AddingFilesModal__zValues____42Ee`,
	"zValuesText": `AddingFilesModal__zValuesText___qo8b2`,
	"coordinatesComboboxWrapper": `AddingFilesModal__coordinatesComboboxWrapper___b4zgv`,
	"containerHeader": `AddingFilesModal__containerHeader___gSKf4`,
	"wellPart": `AddingFilesModal__wellPart___FuLNi`,
	"wellSelect": `AddingFilesModal__wellSelect___WOdXJ`,
	"surveyNamePart": `AddingFilesModal__surveyNamePart___RWX04`,
	"surveyNameInput": `AddingFilesModal__surveyNameInput___Kf6cn`,
	"coordinatesBtn": `AddingFilesModal__coordinatesBtn___LzXHp`,
	"negativeZText": `AddingFilesModal__negativeZText___k16WE`
};
export default ___CSS_LOADER_EXPORT___;
